import { features } from '@/mocks/baoliao';

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            为什么千万读者选择爆料专区
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-4xl mx-auto">
          {features.map((item) => (
            <div
              key={item.id}
              className="text-center p-6 md:p-8 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-colors"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 mx-auto mb-5">
                <i className={`${item.icon} text-primary-600 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-medium text-foreground-900 text-sm md:text-base mb-3">
                {item.title}
              </h3>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}